module.exports = __webpack_public_path__ + "img/luces2.b2d9425e.jpg";